import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-white rounded-xl shadow-xl" }
const _hoisted_2 = { class: "flex items-center justify-between p-4 border-b border-primary-100" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 1,
  class: "w-10 h-10 rounded-full bg-primary-200 flex items-center justify-center text-primary-600 font-medium"
}
const _hoisted_6 = { class: "font-medium text-primary-800" }
const _hoisted_7 = { class: "text-xs text-primary-400" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "p-4 bg-red-50 border-b border-red-200"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-700 mb-3" }, " Are you sure you want to delete this post? This cannot be undone. ", -1)
const _hoisted_15 = { class: "flex gap-2" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "p-4" }
const _hoisted_18 = { class: "text-xl font-heading font-bold text-primary-800 mb-3" }
const _hoisted_19 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = {
  key: 0,
  class: "flex items-center justify-center gap-4 mt-3"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 text-primary-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "text-sm text-primary-500" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5 text-primary-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "flex gap-2 mt-2 overflow-x-auto"
}
const _hoisted_28 = ["src", "alt", "onClick"]
const _hoisted_29 = { class: "text-primary-600 whitespace-pre-wrap" }
const _hoisted_30 = { class: "flex items-center justify-between mt-4 pt-4 border-t border-primary-100" }
const _hoisted_31 = { class: "flex items-center gap-4" }
const _hoisted_32 = { class: "border-t border-primary-100" }
const _hoisted_33 = { class: "p-4" }
const _hoisted_34 = { class: "font-heading font-semibold text-primary-800 mb-4" }
const _hoisted_35 = {
  key: 0,
  class: "space-y-4 mb-4 max-h-80 overflow-y-auto"
}
const _hoisted_36 = {
  key: 0,
  class: "flex items-center gap-1 text-xs text-accent-600 mb-1"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-3 h-3",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M10 2a1 1 0 011 1v1.323l3.954 1.582 1.599-.8a1 1 0 01.894 1.79l-1.233.616 1.738 5.42a1 1 0 01-.285 1.05A3.989 3.989 0 0115 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.715-5.349L11 6.477V16h2a1 1 0 110 2H7a1 1 0 110-2h2V6.477L6.237 7.582l1.715 5.349a1 1 0 01-.285 1.05A3.989 3.989 0 015 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.738-5.42-1.233-.617a1 1 0 01.894-1.788l1.599.799L9 4.323V3a1 1 0 011-1z" })
], -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Pinned ")
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = { class: "flex gap-3" }
const _hoisted_41 = ["src", "alt"]
const _hoisted_42 = {
  key: 1,
  class: "w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center text-primary-500 text-xs font-medium flex-shrink-0"
}
const _hoisted_43 = { class: "flex-1" }
const _hoisted_44 = { class: "bg-primary-50 rounded-lg p-3" }
const _hoisted_45 = { class: "flex items-center justify-between mb-1" }
const _hoisted_46 = { class: "text-xs font-medium text-primary-700" }
const _hoisted_47 = {
  key: 0,
  class: "text-xs text-primary-400"
}
const _hoisted_48 = { class: "text-sm text-primary-600" }
const _hoisted_49 = { class: "flex items-center gap-3 mt-1 ml-1 opacity-0 group-hover:opacity-100 transition-opacity" }
const _hoisted_50 = {
  key: 1,
  class: "text-center py-4 text-primary-400 text-sm"
}
const _hoisted_51 = { class: "flex gap-3 mt-4" }
const _hoisted_52 = ["onKeyup"]
const _hoisted_53 = ["disabled"]

import { ref, computed, PropType, onMounted } from "vue";
import { HoodApi } from "@/services/HoodApi";
import { usePostStore } from "@/stores/posts";
import { useAuthStore } from "@/stores/auth";
import { useReactions } from "@/composables/useReactions";
import ReactionPicker from "@/components/common/ReactionPicker.vue";
import ReactionDisplay from "@/components/common/ReactionDisplay.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  post: {
    type: Object as PropType<Post>,
    required: true,
  },
},
  emits: ["close", "comment-added", "post-deleted"],
  setup(__props, { emit }) {

const props = __props





const postStore = usePostStore();
const authStore = useAuthStore();
const newComment = ref("");
const submitting = ref(false);
const showDeleteConfirm = ref(false);
const deleting = ref(false);
const currentImageIndex = ref(0);

// Computed property for all images (combines legacy image + new images array)
const postImages = computed(() => {
  // Use all_images if available (from API), otherwise fall back to legacy image
  if (props.post.all_images && props.post.all_images.length > 0) {
    return props.post.all_images;
  }
  if (props.post.image) {
    return [props.post.image];
  }
  return [];
});

const nextImage = () => {
  if (currentImageIndex.value < postImages.value.length - 1) {
    currentImageIndex.value++;
  } else {
    currentImageIndex.value = 0;
  }
};

const prevImage = () => {
  if (currentImageIndex.value > 0) {
    currentImageIndex.value--;
  } else {
    currentImageIndex.value = postImages.value.length - 1;
  }
};

// Post reactions
const postReactions = useReactions(
  "post",
  computed(() => props.post.id)
);

// Comment reactions cache
const commentReactionsCache = ref<Record<number, ReactionSummary[]>>({});

onMounted(async () => {
  // Initialize with existing reactions from post data
  if (props.post.reactions) {
    postReactions.reactions.value = props.post.reactions;
  } else {
    await postReactions.fetchReactions();
  }
});

const handlePostReaction = async (type: ReactionType) => {
  await postReactions.toggleReaction(type);
};

const getCommentReactions = (commentId: number): ReactionSummary[] => {
  return commentReactionsCache.value[commentId] || [];
};

const handleCommentReaction = async (commentId: number, type: ReactionType) => {
  // For now, we'll use a simple approach
  // In production, you'd want a more sophisticated caching strategy
  try {
    await HoodApi.toggle_reaction({
      content_type: "comment",
      object_id: commentId,
      reaction_type: type,
    });
    // Refresh comment reactions
    const data = await HoodApi.get_reactions_for_object("comment", commentId);
    commentReactionsCache.value[commentId] = Object.entries(data).map(
      ([rtype, summary]) => ({
        reaction_type: rtype as ReactionType,
        count: summary.count,
        user_reacted: summary.user_reacted,
      })
    );
  } catch (e) {
    console.error("Failed to toggle comment reaction:", e);
  }
};

const isAuthor = computed(() => {
  return props.post.author?.id === authStore.user_id;
});

const sortedComments = computed(() => {
  if (!props.post.comments) return [];
  // Show pinned comments first, then by date (newest first if we have dates)
  return [...props.post.comments].sort((a, b) => {
    if (a.is_pinned && !b.is_pinned) return -1;
    if (!a.is_pinned && b.is_pinned) return 1;
    return 0;
  });
});

const confirmDelete = () => {
  showDeleteConfirm.value = true;
};

const deletePost = async () => {
  deleting.value = true;
  try {
    await postStore.delete_post(props.post.id);
    emit("post-deleted");
  } catch (err) {
    console.error("Failed to delete post:", err);
  } finally {
    deleting.value = false;
  }
};

const authorName = computed(() => {
  const first = props.post.author?.first_name || "";
  const last = props.post.author?.last_name || "";
  return `${first} ${last}`;
});

const authorInitials = computed(() => {
  const first = props.post.author?.first_name?.[0] || "";
  const last = props.post.author?.last_name?.[0] || "";
  return (first + last).toUpperCase();
});

const getCommentInitials = (comment: Comment) => {
  const first = comment.author?.first_name?.[0] || "";
  const last = comment.author?.last_name?.[0] || "";
  return (first + last).toUpperCase();
};

const formatCommentDate = (dateStr: string): string => {
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return "just now";
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;

  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

const categoryLabel = computed(() => {
  const labels: Record<string, string> = {
    looking_to_borrow: "Help Wanted",
    for_sale: "For Sale",
    free: "Free",
    service_to_offer: "Service",
    question: "Question",
    social: "Social",
    general: "General",
  };
  return labels[props.post.type] || "Post";
});

const categoryBadgeClass = computed(() => {
  const classes: Record<string, string> = {
    looking_to_borrow: "bg-orange-100 text-orange-700",
    for_sale: "bg-green-100 text-green-700",
    free: "bg-emerald-100 text-emerald-700",
    service_to_offer: "bg-blue-100 text-blue-700",
    question: "bg-purple-100 text-purple-700",
    social: "bg-pink-100 text-pink-700",
    general: "bg-primary-100 text-primary-700",
  };
  return classes[props.post.type] || classes.general;
});

const friendlyDate = computed(() => {
  const date = new Date(props.post.created_on);
  return date.toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
});

const submitComment = async () => {
  if (!newComment.value.trim() || submitting.value) return;

  submitting.value = true;
  try {
    await HoodApi.make_comment({
      post: props.post.id,
      content: newComment.value.trim(),
    });
    newComment.value = "";
    // Refresh posts to get updated comments
    await postStore.fetch_posts();
    // Notify parent to update the selected post
    emit("comment-added", props.post.id);
  } catch (err) {
    console.error("Failed to post comment:", err);
  } finally {
    submitting.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (__props.post.author?.profile)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: __props.post.author.profile,
              alt: _unref(authorName),
              class: "w-10 h-10 rounded-full object-cover"
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(authorInitials)), 1)),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(authorName)), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(friendlyDate)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_unref(isAuthor))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: confirmDelete,
              class: "p-2 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors",
              title: "Delete post"
            }, _hoisted_10))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
          class: "p-2 text-primary-400 hover:text-primary-600 hover:bg-primary-100 rounded-lg transition-colors"
        }, _hoisted_12)
      ])
    ]),
    (showDeleteConfirm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              onClick: deletePost,
              disabled: deleting.value,
              class: "px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-lg hover:bg-red-700 disabled:opacity-50 transition-colors"
            }, _toDisplayString(deleting.value ? "Deleting..." : "Yes, Delete"), 9, _hoisted_16),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showDeleteConfirm.value = false)),
              class: "px-4 py-2 text-sm font-medium text-primary-600 hover:bg-primary-100 rounded-lg transition-colors"
            }, " Cancel ")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("span", {
        class: _normalizeClass(["inline-block px-2 py-1 text-xs font-medium rounded mb-3", _unref(categoryBadgeClass)])
      }, _toDisplayString(_unref(categoryLabel)), 3),
      _createElementVNode("h2", _hoisted_18, _toDisplayString(__props.post.title), 1),
      (_unref(postImages).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("img", {
              src: _unref(postImages)[currentImageIndex.value],
              alt: __props.post.title,
              class: "w-full max-h-96 object-cover rounded-lg"
            }, null, 8, _hoisted_20),
            (_unref(postImages).length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("button", {
                    onClick: prevImage,
                    class: "p-2 rounded-full bg-primary-100 hover:bg-primary-200 transition-colors"
                  }, _hoisted_23),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(currentImageIndex.value + 1) + " / " + _toDisplayString(_unref(postImages).length), 1),
                  _createElementVNode("button", {
                    onClick: nextImage,
                    class: "p-2 rounded-full bg-primary-100 hover:bg-primary-200 transition-colors"
                  }, _hoisted_26)
                ]))
              : _createCommentVNode("", true),
            (_unref(postImages).length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(postImages), (img, idx) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: idx,
                      src: img,
                      alt: `Image ${idx + 1}`,
                      onClick: ($event: any) => (currentImageIndex.value = idx),
                      class: _normalizeClass(["w-16 h-16 object-cover rounded cursor-pointer transition-all", 
              idx === currentImageIndex.value
                ? 'ring-2 ring-accent-500'
                : 'opacity-60 hover:opacity-100'
            ])
                    }, null, 10, _hoisted_28))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_29, _toDisplayString(__props.post.description), 1),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createVNode(ReactionDisplay, {
            reactions: _unref(postReactions).reactions.value,
            "show-social-proof": true,
            onClick: handlePostReaction
          }, null, 8, ["reactions"])
        ]),
        _createVNode(ReactionPicker, {
          "current-reactions": _unref(postReactions).reactions.value,
          loading: _unref(postReactions).loading.value,
          onSelect: handlePostReaction
        }, null, 8, ["current-reactions", "loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("h3", _hoisted_34, " Comments (" + _toDisplayString(__props.post.comments?.length || 0) + ") ", 1),
        (__props.post.comments && __props.post.comments.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedComments), (comment) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: comment.id || comment.content,
                  class: "group"
                }, [
                  (comment.is_pinned)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_39))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_40, [
                    (comment.author?.profile)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: comment.author.profile,
                          alt: comment.author.first_name,
                          class: "w-8 h-8 rounded-full object-cover flex-shrink-0"
                        }, null, 8, _hoisted_41))
                      : (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(getCommentInitials(comment)), 1)),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("p", _hoisted_46, _toDisplayString(comment.author?.first_name) + " " + _toDisplayString(comment.author?.last_name), 1),
                          (comment.created_on)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(formatCommentDate(comment.created_on)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("p", _hoisted_48, _toDisplayString(comment.content), 1)
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(ReactionPicker, {
                          "show-label": false,
                          position: "top",
                          "current-reactions": getCommentReactions(comment.id),
                          onSelect: (type) => handleCommentReaction(comment.id, type)
                        }, null, 8, ["current-reactions", "onSelect"]),
                        _createVNode(ReactionDisplay, {
                          reactions: getCommentReactions(comment.id),
                          "max-display": 3,
                          "show-label": false,
                          class: "text-xs"
                        }, null, 8, ["reactions"])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_50, " No comments yet. Be the first to comment! ")),
        _createElementVNode("div", _hoisted_51, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newComment).value = $event)),
            type: "text",
            placeholder: "Write a comment...",
            class: "flex-1 px-4 py-2 border border-primary-200 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 transition-colors text-sm",
            onKeyup: _withKeys(submitComment, ["enter"])
          }, null, 40, _hoisted_52), [
            [_vModelText, newComment.value]
          ]),
          _createElementVNode("button", {
            onClick: submitComment,
            disabled: !newComment.value.trim() || submitting.value,
            class: "px-4 py-2 bg-accent-600 text-white font-medium rounded-lg hover:bg-accent-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm"
          }, _toDisplayString(submitting.value ? "..." : "Post"), 9, _hoisted_53)
        ])
      ])
    ])
  ]))
}
}

})